import { render, staticRenderFns } from "./AgendaStatusSession.vue?vue&type=template&id=604d0394&scoped=true&"
import script from "./AgendaStatusSession.vue?vue&type=script&lang=js&"
export * from "./AgendaStatusSession.vue?vue&type=script&lang=js&"
import style0 from "./AgendaStatusSession.vue?vue&type=style&index=0&id=604d0394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d0394",
  null
  
)

export default component.exports